const api = (() => {
  const ConvertStringToJS = (str) => {
    var script = document.createElement("script");
    script.text = str;
    document.head.appendChild(script).parentNode.removeChild(script);
  }
  const ConvertStringToHTML = function (str) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  }

  document.addEventListener('product-color-change', (e) => {
    //console.log(e);
    let $productCard = e.target.closest('.product-card-wrapper');

    let product = e.detail.product;
    let selected_color = e.detail.color;
    let selected_color_variant = product.variants.find(v => v[product.color_option.id] == selected_color);

    if (!selected_color_variant) return;

    // update url
    $productCard.querySelectorAll('a').forEach(($link) => {
      $link.href = `/products/${ product.handle }?variant=${ selected_color_variant.id }`;
    });

    // update image
    let $cardImage = $productCard.querySelector('img');
    let selected_color_img_url = `${ selected_color_variant.featured_media.preview_image.src }&width=1024`;
    $cardImage.srcset = selected_color_img_url
    $cardImage.src = selected_color_img_url;
  });

  return {
    ConvertStringToJS,
    ConvertStringToHTML
  }
})();